import dayjs from "dayjs";

export default {
    install(Vue) {
        // 금액 포멧팅
        Vue.config.globalProperties.formatAmt = function(amt){
            if (amt) {
                return amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "원";
            }
        }

        // 전화번호 포멧팅
        Vue.config.globalProperties.formatPhoneNumber = function(phone){
            if (phone) {
                return phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
            }
        }

        // 날짜 포멧팅
        Vue.config.globalProperties.formatDate = function(date){
            return dayjs(date).format('YYYY-MM-DD')
        }

        // 환경변수를 이용한 이미지베이스 URL
        Vue.config.globalProperties.getRealImgPath = function(path) {
            return process.env.VUE_APP_IMG_SERVER_URL + path
        }

        Vue.config.globalProperties.getImage = function (e) {
            e.target.src = '/_UPLOAD/logo/img_default.png'
        }
    }
}